import React from "react";
import "./Encyclopedia.css";
import Header from "../../Hoc/Header";
import Footer from "../../Hoc/Footer";
import { useLocation } from "react-router-dom";

function Details() {
  const location = useLocation();
  const { title, details, country } = location.state || {};

  return (
    <div className="detail">
      <div className="details">
        <Header title={title || "جزئیات"} />

        <div className="details-body">
          <p className="details-title-span">
            {title} {country}
          </p>

          <div className="details-box">
            <p>{details}</p>
          </div>
        </div>

        <Footer />
      </div>
    </div>
  );
}

export default Details;